import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function
import { auth, dbCentral } from "../../config/FirebaseConfig.js";

const sendInvitationCarnetEmail = async (carnet_id, token, prefix) => {
  // Define the endpoint URL
  const url = prefix + "carnets/" + carnet_id + "/send-invitation";

  // Define the request body
  const body = {};

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request using the Fetch API
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      return {"success": false};
    }

    const db = getFirestore();
    const userRef = doc(dbCentral, "user", currentUser.uid);
    const userSnapshot = await getDoc(userRef);

    if (!userSnapshot.exists()) {
      return {"success": false};
    }

    const orgId = userSnapshot.get("org_id");

    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef.id,
      orgId,
      response.status.toString(),
      "", // Optional additional fields
      "",
      JSON.stringify(body), // Request body as string
      await response.text() // Response body as text
    );

    // Check if the request was successful
    if (response.ok) {
      return {"success": true}; // Success response
    } else {
      console.error(`Failed to send email: ${response.status}`);
      return {"success": false};
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return {"success": false};
  }
};

export default sendInvitationCarnetEmail;
